import { CATEGORY_MODEL_KEY } from 'models/daos/category/constants'
import { isIntegerValidatorUtil } from 'modules/redux/validators/legacy'

const VALIDATOR = {
  [CATEGORY_MODEL_KEY.SECTION_ID]: isIntegerValidatorUtil.bind(
    null, CATEGORY_MODEL_KEY.SECTION_ID
  )
}

function getValidatorCategoryUtil (name) {
  return VALIDATOR[name]
}

export {
  getValidatorCategoryUtil
}
